import React, { useContext } from "react";
import PropTypes from "prop-types";
import { CustomerDropdownCommon } from "./";
import { useTextDomainContext } from "../../providers";

export const CustomerDropdown = (props) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  return (
    <CustomerDropdownCommon
      componentLabel={gettext("Companies")}
      defaultValue={props.defaultValue}
      showAll={props.showAll}
      onChange={props.onChange}
      visualStyle="autoComplete"
    />
  );
};

CustomerDropdown.propTypes = {
  componentLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  showAll: PropTypes.bool,
  onChange: PropTypes.func,
};
